import { useSelector } from 'react-redux';
import { food_chain, REQUIRED_FIELDS, sum, exists_card, exists_card_2, mobilePhone, phone, INT_FIELDS, CSV_HEADERS, FIELD_TO_MAX_CHARS, TEXT_FIELDS, idishCardOptionA, idishCardOptionB, FIELD_TO_MIN_CHARS, id } from "../common/statics";

export const useValidation = () => {
    const file = useSelector(state => state.file);
    const user = useSelector(state => state.user);

    const validateColumn = (columnName, columnValue, row) => {
        const errors = [];
        let phoneOrMobilephoneExist = true;
        switch (columnName) {
            case sum:
                const sumForEachOneResult = isSumForEachOneMatching(columnValue);
                if (sumForEachOneResult !== true)
                    errors.push(sumForEachOneResult);
                break;
            case food_chain:
                if (user.foodChain !== null) {
                    const foodChainResult = foodChainExist(columnValue);
                    if (foodChainResult !== true)
                        errors.push(foodChainResult);
                }
                break;
            case mobilePhone:
                phoneOrMobilephoneExist = isPhoneOrMobilephoneExist(row);
                if (phoneOrMobilephoneExist !== true)
                    errors.push(phoneOrMobilephoneExist);
                break;
            case phone:
                phoneOrMobilephoneExist = isPhoneOrMobilephoneExist(row);
                if (phoneOrMobilephoneExist !== true)
                    errors.push(phoneOrMobilephoneExist);
                break;
            case exists_card:
                const idishCardResult = isIdishCardValid(columnValue);
                if (idishCardResult !== true) {
                    errors.push(idishCardResult);
                }
                break;
            case exists_card_2:
                const idishCardResult2 = isIdishCardValid(columnValue);
                if (idishCardResult2 !== true)
                    errors.push(idishCardResult2);
                break;
            case id:
                const idResult = isIdValid(columnValue);
                if (idResult !== true) {
                    errors.push(idResult);
                }
                break;
            default:
                break;
        }

        const requiredFieldsResult = isRequiredFieldAndExist(columnName, columnValue);
        if (requiredFieldsResult !== true)
            errors.push(requiredFieldsResult);

        const columnTypeMatching = isColumnTypeMatching(columnName, columnValue);
        if (columnTypeMatching !== true)
            errors.push(columnTypeMatching);


        const columnTypeMatchingText = isColumnTypeMatchingText(columnName, columnValue);
        if (columnTypeMatchingText !== true)
            errors.push(columnTypeMatchingText);



        const lengthMatching = isLengthMatching(columnName, columnValue);
        if (lengthMatching !== true)
            errors.push(lengthMatching);

        return errors;
    }

    const getDuplicateIds = () => {
        const counts = (file || []).reduce((acc, row) => {
            const value = row[id];
            const normalized = value === undefined || value === null ? "" : String(value).trim();
            if (normalized !== "") {
                acc[normalized] = (acc[normalized] || 0) + 1;
            }
            return acc;
        }, {});
        return Object.keys(counts).filter(key => counts[key] > 1);
    }


    const isIdValid = (columnValue) => {
        const duplicateIds = getDuplicateIds();
        const normalized = columnValue === undefined || columnValue === null ? "" : String(columnValue).trim();
        if (normalized !== "" && duplicateIds.includes(normalized)) {
            return "ת.ז. כפול";
        }
        return true;
    }

    const isIdishCardValid = (columnValue) => {
        if (columnValue !== "" && columnValue !== undefined) {
            if (/^\d+$/.test(columnValue)) {
                return true;
            }
            if (columnValue === idishCardOptionA || columnValue === idishCardOptionB) {
                return true;
            }
            return "שדה מספר";
        }
        return true;
    }

    const isLengthMatching = (columnName, columnValue) => {
        if (columnValue === idishCardOptionA || columnValue === idishCardOptionB) {
            return true;
        }
        const columnToMaxChars = FIELD_TO_MAX_CHARS.find(item => columnName in item);
        if (columnToMaxChars) {
            const max = columnToMaxChars[columnName];
            const maxOk = shortThenMaxChars(columnValue, max)
            if (maxOk !== true)
                return maxOk;
        }
        const columnToMinChars = FIELD_TO_MIN_CHARS.find(item => columnName in item);
        if (columnToMinChars) {
            const min = columnToMinChars[columnName];
            const minOk = shortThenMinChars(columnValue, min)
            if (minOk !== true)
                return minOk;
        }
        return true;
    }

    const isSumAllMatching = (rows, newValue) => {
        const calcSum = rows.length * newValue;
        return calcSum < (user.approvalAmount - user.enteredAmount);
    }

    const calcIfSumAllMatching = () => {
        const totalSum = calculateTotalSum(file);
        return totalSum > (user.approvalAmount - user.enteredAmount);
    }

    const calculateTotalSum = () => {
        let totalSum = 0;
        file.forEach((item) => {
            totalSum += Number(item[sum]) || 0;
        });
        return totalSum;
    };

    const isColumnTypeMatching = (columnName, columnValue) => {
        if (INT_FIELDS.includes(columnName)) {
            if (columnValue !== "" && columnValue !== undefined && !(/^\d+$/.test(columnValue))) {
                return "שדה מספרי!";
            }
        }
        return true;
    }

    const isColumnTypeMatchingText = (columnName, columnValue) => {
        if (TEXT_FIELDS.includes(columnName)) {
            if (columnValue !== "" && (/^\d+$/.test(columnValue))) {
                return "שדה טקסט!";
            }
        }
        return true;
    }

    const isRowsExists = (rows) => {
        return rows.length > 0;
    }

    const isSumForEachOneMatching = (columnValue) => {
        if (user.amountLimitForEach !== null && columnValue > user.amountLimitForEach) {
            return "סכום גבוה מהסכום שאושר"
        }
        return true
    }

    const shortThenMaxChars = (columnValue, maxChars) => {
        if (columnValue?.length > maxChars) {
            return "מקסימום " + maxChars + " תווים";
        }
        return true
    }

    const shortThenMinChars = (columnValue, minChars) => {
        if (columnValue?.length < minChars) {
            return "מינימום " + minChars + " תווים";
        }
        return true
    }

    const isRequiredFieldAndExist = (columnName, columnValue) => {
        const requiredFields = REQUIRED_FIELDS(user);
        if (requiredFields.includes(columnName)) {
            if (columnValue === "" || columnValue === undefined) {
                return "שדה חובה!";
            }
        }
        return true
    }

    const isPhoneOrMobilephoneExist = (row) => {
        if (isEmptyColumn(mobilePhone, row) && isEmptyColumn(phone, row)) {
            return "חובה למלא טלפון או פלאפון";
        }
        return true
    }

    const isEmptyColumn = (column, row) => {
        const a = row[column] === "" || row[column] === undefined;
        return a
    }

    const foodChainExist = (columnValue) => {
        if (user.foodChain === null && columnValue === "") {
            return "שדה חובה!"
        }
        return true;
    }

    const isColumnsMatched = () => {
        return file && Object.keys(file?.[0]).every(key => CSV_HEADERS.includes(key));
    }

    return { validateColumn, isSumAllMatching, calcIfSumAllMatching, calculateTotalSum, isColumnTypeMatching, isRowsExists, isColumnsMatched }

}